// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"e98c1bc3","278":"76786d0f","405":"c01986e2","488":"f2f58a21","596":"a079426d","748":"34af6335","841":"86964955","885":"4875420a"}[chunkId] + ".chunk.js";
};